import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONSTANTS } from '../shared/constants';

declare var gigya: any;

@Injectable()
export class ProfileService {

  constructor() { }

  /*
   * Show Gigya screenset to edit profile
  */
  public editProfile(): Observable<any> {
    return Observable.create((observer) => {
      gigya.accounts.showScreenSet({
        screenSet: CONSTANTS.gigyaConfig.screenSetId,
        startScreen: CONSTANTS.gigyaConfig.updateStartScreenSet,
        lang : CONSTANTS.gigyaConfig.language,
        regSource : CONSTANTS.gigyaConfig.domain,
        sessionExpiration : -2,
        onAfterSubmit: retrieveEditProfileResponse
      });
      function retrieveEditProfileResponse(eventObj) {
        if(eventObj.response.status === CONSTANTS.status.okay && eventObj.response.errorCode === 0) {
          observer.next(eventObj.profile);
          observer.complete();
          ProfileService.closeEditProfileScreenSet();          
        }
      }
    });
  }

  /*
   * Show Gigya screenset to change password
  */
  public changePassword(): Observable<any> {
    return Observable.create((observer) => {
      gigya.accounts.showScreenSet({
        screenSet: CONSTANTS.gigyaConfig.screenSetId,
        startScreen: CONSTANTS.gigyaConfig.changePasswordScreenSet,
        lang : CONSTANTS.gigyaConfig.language,
        regSource : CONSTANTS.gigyaConfig.domain,
        sessionExpiration : -2,
        onAfterSubmit: retrieveChangePasswordResponse        
      });
      function retrieveChangePasswordResponse(eventObj) {
        if(eventObj.response.status === CONSTANTS.status.okay && eventObj.response.errorCode === 0) {
          observer.next();
          observer.complete();
          ProfileService.closeEditProfileScreenSet();          
        }
      }
    });
  }

  /*
   * Gigya function to change profile photo
  */
  public changeProfilePhoto(encodedImageString): Observable<any> {
    return Observable.create((observer) => {
      const imageString = encodedImageString.substr((encodedImageString.lastIndexOf(',') + 1));
      gigya.accounts.setProfilePhoto({
        photoBytes: imageString, // '<BASE64-encoded-image-string>'
        publish: 'true',
        callback: retrieveSetProfilePhotoResponse
      });
      function retrieveSetProfilePhotoResponse(response) {
        if(response && response.status === CONSTANTS.status.okay && response.errorCode === 0) {
          observer.next();
          observer.complete();
        }          
      }
    });
  }

  /*
   * Gigya function to retrieve info of logged-in user (if the session is active)
  */
  public getAccountInfo(): Observable<any> {
    return Observable.create((observer) => {
      gigya.accounts.getAccountInfo({ 
        callback: getAccountInfoResponse 
      });
      function getAccountInfoResponse(eventObj) {
        let activeSession = eventObj.UID !== null && eventObj.UID !== '' && eventObj.errorCode === 0;
        if(activeSession) {
          observer.next(eventObj.profile);
          observer.complete();
        }
    }
    });
  }

  /*
   * Gigya function to hide a screenset
  */
  public static closeEditProfileScreenSet(): void {
    gigya.accounts.hideScreenSet({
      screenSet: CONSTANTS.gigyaConfig.screenSetId
    });
  }

}




// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/profile.service.ts